import moment from 'moment'
import React from 'react'
import Switch from 'react-bootstrap-switch'
import ReactDatePicker from 'react-datepicker'

const RelativePicker = (props) => {
  const { onChange, units, count, options } = props

  const handleRelativeDateChange = (ev) => {
    const { value, name } = ev.target
    onChange({ name, value })
  }

  // It's more intuitive if they both work as 'before' when negative
  const desc = count < 0 ? 'before' : 'after'
  let descPluralized = (count == 1 ? units : units + 's') + ' ' + desc
  if (units === 'future') {
    descPluralized = 'Events with upcoming start dates'
  }

  return (
    <>
      <div className='form-group'>
        <div className='inline-label-wrapper'>
          <label>Offset</label>
          <input
            disabled={units === 'future'}
            className='form-control'
            type='number'
            name='count'
            value={parseInt(count, 10) || 0}
            onChange={handleRelativeDateChange}
          />
        </div>
      </div>
      <div className='form-group'>
        <div className='inline-label-wrapper'>
          <label>Duration</label>
          <select
            className='form-control'
            style={{ display: 'inline-flex' }}
            name='units'
            onChange={handleRelativeDateChange}
            value={units}
          >
            <option disabled value=''>
              Select One &hellip;
            </option>
            {options.map(function (unit, optionIndex) {
              var pluralized =
                count == 1 || unit === 'future' ? unit : unit + 's'
              return (
                <option key={unit + '-option-' + optionIndex} value={unit}>
                  {pluralized.capitalizeWord()}
                </option>
              )
            })}
          </select>
        </div>
      </div>
      <div className='form-group'>
        <p>
          <span className='relativeDateDescription'>
            <strong>
              <em>
                {count > 0 || count < 0 || units === 'future'
                  ? (count > 0 && units !== 'future'
                      ? count
                      : count.toString().slice(1)) +
                    ' ' +
                    descPluralized
                  : 'Day Of'}
              </em>
            </strong>
          </span>
        </p>
      </div>
    </>
  )
}

const AbsolutePicker = (props) => {
  const { absolute, onChange, otherPreferences, preferenceName } = props
  const date = moment.isMoment(absolute) ? absolute : moment(absolute)
  let maxDate
  let minDate
  if (
    preferenceName === 'startDateTime' &&
    otherPreferences.stopDateTime.absolute
  ) {
    maxDate =
      otherPreferences.stopDateTime.absolute &&
      moment.isMoment(otherPreferences.stopDateTime.absolute)
        ? otherPreferences.stopDateTime.absolute
        : moment(otherPreferences.stopDateTime.absolute)
  } else if (
    preferenceName === 'stopDateTime' &&
    otherPreferences.startDateTime.absolute
  ) {
    minDate =
      otherPreferences.startDateTime.absolute &&
      moment.isMoment(otherPreferences.startDateTime.absolute)
        ? otherPreferences.startDateTime.absolute
        : moment(otherPreferences.startDateTime.absolute)
  }

  const handleChange = (date) => {
    onChange({ name: 'absolute', value: date })
  }

  return (
    <div className='input-group' style={{ marginLeft: '1rem' }}>
      <span className='input-group-addon'>
        <i className='fa fa-calendar' />
      </span>
      <ReactDatePicker
        fixedHeight={true}
        showYearDropdown
        showMonthDropdown
        peekNextMonth
        className='form-control'
        dateFormat='MM/DD/YYYY'
        selected={date}
        onChange={handleChange}
        maxDate={maxDate}
        minDate={minDate}
      />
    </div>
  )
}

const DateInput = (props) => {
  const { value, options, preferenceName, storeEdits, otherPreferences } = props
  const { count, units, absolute } = value

  const handleChange = ({ name, value }) => {
    const updates = {
      count: count,
      units: units,
      [name]: value,
    }
    storeEdits(updates)
  }

  const handleDateTypeChange = (ev) => {
    handleChange({
      name: 'absolute',
      value: !!value.absolute ? null : new Date(),
    })
  }
  return (
    <div>
      <div className='form-inline'>
        <div className='form-group'>
          <Switch
            value={!!absolute}
            onChange={handleDateTypeChange}
            animate={false}
            onText='Absolute'
            offText='Relative'
            offColor='primary'
          />
        </div>
        {!!absolute ? (
          <AbsolutePicker
            preferenceName={preferenceName}
            onChange={handleChange}
            absolute={absolute}
            otherPreferences={otherPreferences}
          />
        ) : (
          <RelativePicker
            onChange={handleChange}
            options={options}
            units={units}
            count={count}
          />
        )}
      </div>
    </div>
  )
}

export default DateInput
